<ideal-navigation-list [items]="items()" />
